import {
  ExternalChannelActionTypes,
  IGetExternalVideosSuccessResponseBody,
  IGetExternalChannelsSuccessResponseBody,
  IRemoveExternalChannelPayload
} from './types'

export const getExternalVideos = () => ({
  type: ExternalChannelActionTypes.GET_EXTERNAL_VIDEOS
})

export const getExternalVideosFailure = () => ({
  type: ExternalChannelActionTypes.GET_EXTERNAL_VIDEOS_FAILURE
})

export const getExternalVideosSuccess = (payload: IGetExternalVideosSuccessResponseBody) => ({
  type: ExternalChannelActionTypes.GET_EXTERNAL_VIDEOS_SUCCESS,
  payload
})

export const increasePageCount = () => ({
  type: ExternalChannelActionTypes.INCREASE_PAGE_COUNT
})

export const decreasePageCount = () => ({
  type: ExternalChannelActionTypes.DECREASE_PAGE_COUNT
})

export const getExternalChannels = () => ({
  type: ExternalChannelActionTypes.GET_EXTERNAL_CHANNELS
})

export const getExternalChannelsFailure = () => ({
  type: ExternalChannelActionTypes.GET_EXTERNAL_CHANNELS_FAILURE
})

export const getExternalChannelsSuccess = (payload: IGetExternalChannelsSuccessResponseBody) => ({
  type: ExternalChannelActionTypes.GET_EXTERNAL_CHANNELS_SUCCESS,
  payload
})

export const openActionsDropdown = () => ({
  type: ExternalChannelActionTypes.OPEN_ACTIONS_DROPDOWN
})

export const closeDropdowns = () => ({
  type: ExternalChannelActionTypes.CLOSE_DROPDOWNS
})

export const removeExternalChannel = (payload: IRemoveExternalChannelPayload) => ({
  type: ExternalChannelActionTypes.REMOVE_EXTERNAL_CHANNEL,
  payload
})
